import AuditLogViewer from '../components/AuditLogViewer'

export default function AuditPage() {
  return (
    <div className="p-6 animate-fade-in">
      <h1 className="text-2xl font-bold mb-6">Журнал аудита</h1>
      <AuditLogViewer />
    </div>
  )
}
